/**
 * Generate a simple password similar to onboarding process
 * Format: 8 alphanumeric characters in uppercase
 * Example: "A3K9F2XY"
 */
export const generateSimplePassword = (): string => {
  return Math.random().toString(36).substring(2, 10).toUpperCase();
};
